import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import patchNotes from '../patchNotes';

const PatchNotes: React.FC = () => {
    const [showUpdateBanner, setShowUpdateBanner] = useState(false);

    useEffect(() => {
        if (window.location.hash === '#updateAvailable') {
            setShowUpdateBanner(true);
        }
    }, []);

    return (
        <div className="flex flex-col justify-center items-center bg-dark-blue text-gray-300 p-4 w-[100em] pb-10">
            {showUpdateBanner && (
                <div className="bg-green-800 text-white px-4 py-3 rounded relative mb-4 w-full max-w-3xl" role="alert">
                    <strong className="font-bold">Update Available!</strong>
                    <span className="block sm:inline"> Deck Hopper will update automatically after restarting.</span>
                    <span className="block sm:inline"> (Not downloading? <a href="https://github.com/christinna9031/Deck-Hopper?tab=readme-ov-file#download" className="underline font-bold text-orange-400" target="_blank" rel="noopener noreferrer">Download here</a>)</span>
                </div>
            )}

<h1 className="text-4xl text-center text-white mb-4 mt-4">Patch Notes</h1>
      <p className="text-xl text-center text-gray-400 mb-6">
        Stay up-to-date with the latest changes in Deck Hopper.
      </p>
      <hr className="border-t border-gray-600 w-2/3 mb-8" />

            <div className="flex flex-col items-center max-w-[70em]">
                <div className="patchnotes flex flex-col p-8 prose-invert">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {patchNotes}
                    </ReactMarkdown>
                </div>
            </div>
        </div>
    );
};

export default PatchNotes;
